import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { finalize, take, takeUntil } from 'rxjs';

import { DialogService, FormNavigationService, SpinnerService } from 'dspx-core';

import { API_ENDPOINTS } from '../../constants/api-endpoints.constants';
import { ROUTE_CONSTANTS } from '../../constants/route.constants';
import { TEMPLATES } from '../../constants/templates.constants';
import { POP_UP_CODES, QUESTION_PATHS } from '../../constants/app-data.constants';

import { ManageBatchesGridFilterRequestInterface } from '../../interfaces/manage-batches-grid-filter-request.interface';

import { ServiceWorkerService } from '../../services/service-worker.service';
import { AppDataService } from '../../services/app-data.service';
import { ExcelImportService } from '../../services/excel-import.service';
import { ResponseParserService } from '../../services/response-parser.service';
import { ErrorService } from '../../services/error.service';
import { HtmlHelperService } from '../../services/html-helper.service';

import { BaseCardSetListComponent } from '../base-card-set-list-component/base-card-set-list.component';

@Component({
  selector: 'app-batch-list',
  templateUrl: './batch-list.component.html',
  styleUrl: './batch-list.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class BatchListComponent extends BaseCardSetListComponent implements OnInit, OnDestroy {

  activeDialog: string = '';

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected serviceWorkerService: ServiceWorkerService,
    protected appDataService: AppDataService,
    protected spinnerService: SpinnerService,
    protected htmlHelperService: HtmlHelperService,
    protected dialogService: DialogService,
    protected responseParserService: ResponseParserService,
    protected excelImportService: ExcelImportService,
    protected formNavigationService: FormNavigationService,
    private errorService: ErrorService,
  ) {
    super(
      router,
      serviceWorkerService,
      appDataService,
      spinnerService,
      htmlHelperService,
      dialogService,
      responseParserService,
      formNavigationService);

    this.initialise(
      TEMPLATES.batchList,
      () => API_ENDPOINTS.dashboard.getBatches,
      true);
  }

  ngOnInit(): void {
    this.ignoreCanDeactivateGuard = true;
    this.overrideHtmlTitleSetByDspxFrameworkOnFormNavigation();
    this.waitForServiceWorker();
  }

  ngOnDestroy(): void {
    this.completeDestroy();
  }

  formLoad(event: any): void {
    this.configData = event.configData;
    this.loadGridDataOnFormLoad();
  }

  filterData(event: any): void {
    const filterRequest = this.getFilterRequest();
    this.loadGridData(filterRequest);
  }

  actionButton_batchesPlaceholder_datagrid_reviewBatch_Clicked(event: any): void {
    this.router.navigate(['/', ROUTE_CONSTANTS.inspection.list, 'batchId', event.event.data.batchId]);
  }

  actionButton_batchesPlaceholder_datagrid_acceptBatch_Clicked(event: any): void {
    const batchId = event.event.data.batchId;
    this.postBatchAction(
      API_ENDPOINTS.batch.submitBatch,
      {
        batchId: batchId,
        isAccepted: true
      },
       POP_UP_CODES.batchList.successfulInspectionBatchApprove
    );
  }

  actionButton_batchesPlaceholder_datagrid_rejectBatch_Clicked(event: any): void {
    const batchId = event.event.data.batchId;
    this.postBatchAction(
      API_ENDPOINTS.batch.submitBatch,
      {
        batchId: batchId,
        isAccepted: false
      },
      POP_UP_CODES.batchList.successfulInspectionBatchReject
    );
  }

  private getFilterRequest(): ManageBatchesGridFilterRequestInterface {
    const filterQuestionModel = this.getQuestionValue(this.model, ...QUESTION_PATHS.batchList.filter);

    const filterRequest: ManageBatchesGridFilterRequestInterface = {
      batchStatus: filterQuestionModel?.batchStatus,
      organisation: filterQuestionModel?.organisation
    };

    return filterRequest;
  }

  private postBatchAction(
    apiEndPoint: string,
    payload: any,
    resultPopupCode: string,
  ): void {
    this.spinnerService.showSpinner();
    this.appDataService.post(apiEndPoint, payload)
      .pipe(take(1),
        takeUntil(this.destroy$),
        this.errorService.errorHandler(),
        finalize(() => this.spinnerService.hideSpinner())
      )
      .subscribe(data => {
        if (resultPopupCode) {
          if (Number(data.result) === 3) {
            this.dialogService.showPopup(resultPopupCode, {}, {});
            this.loadGridDataOnFormLoad();
          }
          else if (Number(data.result) === 5) {
            this.dialogService.showPopup(POP_UP_CODES.batchList.noInspectionsToApproveError, {}, {});
          }
          else {
            this.dialogService.showPopup(POP_UP_CODES.batchList.saveInspectionBatchError, {}, {});
          }
        }        
      });
  }
}
